// 这里放置一些Vue自定义Filter
/* eslint-disable */
import moment from 'moment'
import 'moment/locale/zh-cn'
moment.locale('zh-cn')

const toTwo = number => {
  if (typeof number !== 'number') return
  return number.toString().padStart(2, '0')
}

export const formatDate = time => {
  if (time) {
    let tmpDate = new Date(time)
    let year = tmpDate.getFullYear()
    let mathon = tmpDate.getMonth() + 1
    if (mathon < 10) {
      mathon = '0' + mathon
    }
    let day = tmpDate.getDate()
    if (day < 10) {
      day = '0' + day
    }
    return year + '-' + mathon + '-' + day
  } else {
    return ''
  }
}

export const formatTime = time => {
  if (!time) return ''
  return moment(time).format('YYYY-MM-DD HH:mm')
}

export const formatTimeNoYear = time => {
  return moment(time).format('MM-DD HH:mm')
}

export const ChineseTime = (time) => {
  return moment(time).format("YYYY年MM月DD日")
}

export const getFullNameFromUrl = url => {
  if (!url || typeof url !== 'string') return ''
  return decodeURIComponent(url.substring(url.lastIndexOf('/') + 1))
}

export const getNameFromFull = fullName => {
  if (!fullName) return ''
  return fullName.substring(0, fullName.lastIndexOf('.'))
}

export const getTypeFromFull = fullName => {
  if (!fullName) return ''
  return fullName.substring(fullName.lastIndexOf('.'))
}

export const isImage = url => {
  if (!url) return
  const type = getTypeFromFull(getFullNameFromUrl(url))
  const pictureType = [
    '.jpeg',
    '.jpg',
    '.svg',
    '.gif',
    '.png',
    '.bmp',
    '.tif',
    '.webp',
    '.jfif'
  ]

  return pictureType.includes(type)
}

export const docsType = ['.doc', '.docx']

export const pdfsType = ['.pdf']

export const excelsType = ['.xls', '.xlsx']

export const videoType = ['.mp4']

export const filterTime = old=>{
  return formatTime(old)
}
